import type { FieldType, UISchema } from '@carboncopyco/editor-utils';
import {
  BooleanField,
  NumberField,
  ObjectField,
  TableField,
  TextField,
} from './fields';
import type { BaseFieldProps } from './fields/types';

const fieldTypeToComponent: Record<FieldType, React.ElementType> = {
  boolean: BooleanField,
  number: NumberField,
  text: TextField,
  table: TableField,
  object: ObjectField,
  date: null,
};

export const FormField = <S extends UISchema, V>(
  props: BaseFieldProps<S, V>
) => {
  const FieldComponent = fieldTypeToComponent[props.field.uiSchema.type];

  return FieldComponent ? <FieldComponent {...props} /> : null;
};
